import { createRouter, createWebHistory } from 'vue-router'
import ArchivePage from '../components/ArchivePage'
import AboutPage from '../components/AboutPage'
import HomePage from '../components/HomePage'
import WrongWay from '../components/WrongWay'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage
    },
    {
      path: '/about',
      name: 'about',
      component: AboutPage
    },
    {
      path: '/archives/:id',
      name: 'archive',
      component: ArchivePage
    },
    {
      path: '/archives',
      name: 'archiveblank',
      component: WrongWay
    },
  ]
})


export default router
